var _rect, _rect2, _rect3, _rect4, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_750_1453",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 24,
    height: 24,
    transform: "rotate(90 24 0)",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_750_1453)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_750_1453",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 14,
    width: 10,
    height: 10
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.8241,
    y: 18.105,
    width: 2,
    height: 3.5954,
    transform: "rotate(9.46173 9.8241 18.105)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3097,
    y: 19.6953,
    width: 2,
    height: 3.5954,
    transform: "rotate(-19.9974 12.3097 19.6953)",
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.42432,
    y: 14,
    width: 1.08736,
    height: 1.57297,
    transform: "rotate(64.89 7.42432 14)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_750_1453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.05 16.675C8.21667 17.6417 8.67083 18.4375 9.4125 19.0625C10.1542 19.6875 11.0167 20 12 20C13.1 20 14.0417 19.6083 14.825 18.825C15.6083 18.0417 16 17.1 16 16C16 15.0167 15.6875 14.1542 15.0625 13.4125C14.4375 12.6708 13.6417 12.2167 12.675 12.05C12.1917 11.9667 11.7917 11.7417 11.475 11.375C11.1583 11.0083 11 10.5833 11 10.1V5.825L9.4 7.425L8 6L12 2L16 6L14.6 7.4L13 5.825V10.075C14.4667 10.3083 15.6667 10.9875 16.6 12.1125C17.5333 13.2375 18 14.5333 18 16C18 17.6667 17.4167 19.0833 16.25 20.25C15.0833 21.4167 13.6667 22 12 22C10.5333 22 9.2375 21.5333 8.1125 20.6C6.9875 19.6667 6.30833 18.4667 6.075 17L8.05 16.675Z",
    fill: "#3A5F77"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.825 18.825C15.6083 18.0417 16 17.1 16 16C16 15.0167 15.6875 14.1542 15.0625 13.4125C14.4375 12.6708 13.6417 12.2167 12.675 12.05C12.1917 11.9667 11.7917 11.7417 11.475 11.375C11.1583 11.0083 11 10.5833 11 10.1V5.825L9.4 7.425L8 6L12 2L16 6L14.6 7.4L13 5.825V10.075C14.4667 10.3083 15.6667 10.9875 16.6 12.1125C17.5333 13.2375 18 14.5333 18 16C18 17.6667 16.25 20.25 16.25 20.25L14.825 18.825Z",
    fill: "#3A5F77"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.936e2a32560e75bba77eff20af608272.svg";
export { ForwardRef as ReactComponent };